import {noop} from '@benchling/js-utils';
import React from 'react';

import {assert} from 'Asserts';
import {Registry} from 'constants/RegistryConstants';
import {ModalPane, StorableModalCreateProps} from 'constants/SampleConstants';
import {TagsDict} from 'folder-items/FileConstants';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {filterToValidAllowedChildSchemaIds} from 'samples/storables/editable-fields/EditableLocationAllowedChildSchemasField';
import * as TagUtil from 'schemas/tags/TagUtil';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';

import {LocationSummaryGraphQL} from '../../graphql-fragments/inventory/__generated/LocationSummaryGraphQL';
import CreateLocationPane, {CreateLocationPaneState} from './CreateLocationPane';
import CreateStorableModal from './CreateStorableModal';
import * as StorableActions from './StorableActions';

export interface CreateLocationModalProps {
  initialRegistry: Registry | null;
  initialParentStorable: LocationSummaryGraphQL | null;
  onRequestClose?: () => void;
  actionOrigin: ActionOrigin;
}

class CreateLocationModal extends React.Component<CreateLocationModalProps> {
  static open = (props: CreateLocationModalProps): void => {
    LegacyModalContainer.open(
      CreateLocationModal,
      <CreateLocationModal {...props} onRequestClose={CreateLocationModal.close} />
    );
  };

  static close = (): void => {
    LegacyModalContainer.close(CreateLocationModal);
  };

  private handleCreateLocation = (
    onFinish: (errorMessage?: string) => void,
    createPropsArray: Array<StorableModalCreateProps>,
    paneState: CreateLocationPaneState
  ): void => {
    assert(createPropsArray.length === 1, 'Expected createPropsArray to have length 1.');
    const createProps = createPropsArray[0];
    if (!TagUtil.areTagsValidAndNotify(createProps.tags)) {
      return;
    }

    const tagsDict: TagsDict = {};
    TagUtil.tagUpdateObjectToTagsDict(TagUtil.getTagsToSet(createProps.tags), tagsDict);

    StorableActions.createLocation(
      createProps.selectedSchemaId,
      createProps.name,
      {
        barcode: createProps.barcode,
        parentStorableData: createProps.parentStorableData,
        tags: tagsDict,
        // Capacity params
        allowsNonLocationChildren: paneState.allowsNonLocationChildren,
        allowedChildStorableSchemaApiIds: paneState.allowsNonLocationChildren
          ? filterToValidAllowedChildSchemaIds(paneState.allowedChildStorableSchemaApiIds)
          : null,
        capacity: paneState.allowsNonLocationChildren ? paneState.capacity : null,
      },
      onFinish
    );
  };

  override render(): JSX.Element {
    return (
      <CreateStorableModal
        initialParentStorable={this.props.initialParentStorable}
        initialRegistry={this.props.initialRegistry}
        modalPane={ModalPane.CREATE_LOCATION}
        onCreate={this.handleCreateLocation}
        onRequestClose={this.props.onRequestClose ?? noop}
        paneClass={CreateLocationPane}
        analyticsMetadata={{actionOrigin: this.props.actionOrigin}}
      />
    );
  }
}

export default CreateLocationModal;
